<template>
  <span>
    <div id="bookingAccordion">
      <BookingAccordionRow v-for="booking in bookings.data" :key="booking.id"  :booking="booking"/>
    </div>
    <pagination :links="bookings.links"/>
  </span>
</template>

<script>
import BookingAccordionRow from "@/Shared/BookingAccordion/BookingAccordionRow";
import Pagination from '@/Shared/Pagination'

export default {
  name: "BookingAccordion",
  components: {
    BookingAccordionRow,
    Pagination
  },
  props: {
    bookings: {
      type: Object,
      required: true,
    }
  },
}
</script>
